// src/components/LeaveCoupleConfirm.js
// 커플 탈퇴 확인 모달 — 되돌릴 수 없는 작업이므로 경고를 모아 보여주고
// '탈퇴'를 직접 입력해야 실행 버튼이 활성화된다.
import React, { useState } from 'react';
import '../styles/LeaveCoupleConfirm.css';

const CONFIRM_WORD = '탈퇴';

const LeaveCoupleConfirm = ({ onClose, onConfirm, isLoading = false }) => {
    const [typed, setTyped] = useState('');

    const canSubmit = typed.trim() === CONFIRM_WORD && !isLoading;

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('leave-couple-overlay') && !isLoading) {
            onClose();
        }
    };

    return (
        <div className="leave-couple-overlay" onClick={handleOverlayClick}>
            <div className="leave-couple-modal">
                <div className="leave-couple-header">
                    <h2>⚠️ 커플 탈퇴</h2>
                </div>

                <div className="leave-couple-body">
                    <ul className="leave-warning-list">
                        <li>공유한 다이어리와 타임캡슐을 <strong>더 이상 볼 수 없게</strong> 됩니다.</li>
                        <li>탈퇴 후 재가입하셔도 <strong>데이터는 복원되지 않습니다.</strong></li>
                        <li>이 작업은 <strong>되돌릴 수 없습니다.</strong></li>
                    </ul>

                    <p className="leave-confirm-question">그래도 탈퇴하시겠습니까?</p>

                    <label htmlFor="leaveConfirmInput" className="leave-confirm-label">
                        계속하려면 <code>{CONFIRM_WORD}</code>를 입력해주세요.
                    </label>
                    <input
                        id="leaveConfirmInput"
                        type="text"
                        value={typed}
                        onChange={(e) => setTyped(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter' && canSubmit) onConfirm(); }}
                        className="leave-confirm-input"
                        placeholder={CONFIRM_WORD}
                        autoComplete="off"
                        autoFocus
                        disabled={isLoading}
                    />
                </div>

                <div className="leave-couple-actions">
                    <button
                        type="button"
                        className="leave-cancel-btn"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        취소
                    </button>
                    <button
                        type="button"
                        className="leave-submit-btn"
                        onClick={onConfirm}
                        disabled={!canSubmit}
                    >
                        {isLoading ? '탈퇴 처리 중...' : '탈퇴하기'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LeaveCoupleConfirm;
